import {useState} from 'react';
import {Alert, Button, EmailField} from '@bonprix/design-system';
import Url from '@core/scripts/helper/url';
import fetchWithCsrf from '../../../../../../../core/src/main/resources/scripts/helper/fetch-with-csrf.js';
import {TrinityEvents} from '@service/scripts/trinity.js';
import {trimFormValues} from '../helpers.jsx';

/**
 * @param {Object} props
 * @param {NewsletterUnsubscribeForm} props.cdaEntry
 */
export function NewsletterUnsubscribeForm({cdaEntry}) {
    const [formValues, setFormValues] = useState({
        email: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [formErrors, setFormErrors] = useState({});

    const handleChange = (name) => (valueOrEvent) => {
        // Keep typing updates synchronous to avoid cursor jumping in controlled inputs.
        // Some components pass the new value, others pass an event.
        const nextValue = valueOrEvent?.target ? valueOrEvent.target.value : valueOrEvent;
        setFormValues((prev) => ({...prev, [name]: nextValue}));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setFormErrors({});
        setErrorMsg("");
        setIsSubmitting(true);

        //track unsubscribe event
        TrinityEvents.sendClickNewsletter('continueNewsletterUnsubscription', 'button');

        const trimmedFormValues = trimFormValues(formValues);

        fetchWithCsrf(Url.toAbsolute(cdaEntry.unsubscribeApiUrl), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(trimmedFormValues),
        })
        .then((response) => response.json())
        .then((data) => {
            if(data.errors){
                setFormErrors(data.errors);
            }
            if(data.errorMsg){
                setErrorMsg(cdaEntry.genericErrorMessage);
            }

            //redirect to real unsubscribe page
            if(data.success){
                window.location = Url.toAbsolute(`/newsletter/unsubscribe/`);
            }
        })
        .catch((error) => {
            console.error(error);
            setErrorMsg("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.");
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    return (
        <div className="service-page-newsletter-unsubscribe-form">
            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <EmailField
                        label={cdaEntry.labelEmail}
                        required
                        inputMode="email"
                        value={formValues.email}
                        name="email"
                        onChange={handleChange('email')}
                        error={formErrors && !!formErrors.email}
                        errorText={formErrors && formErrors.email && cdaEntry.errorEmail}
                    />
                </div>

                {errorMsg && (
                    <div className="form-row">
                         <Alert isOpen status="error" showCloseIcon={false}>{errorMsg}</Alert>
                    </div>
                )}

                <div className="form-row">
                    <Button type="submit" loading={isSubmitting}>
                        {cdaEntry.labelButtonSubmit}
                    </Button>
                </div>
            </form>
        </div>
    )
}
